import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    width: '150px',
    height: '150px',
    margin:'25px',
    marginTop:'11px',
    marginBottom: '11px',
  },
  hoverable:{
    '&:hover':{
      cursor:'pointer',
      backgroundColor: theme.palette.blue.lighter,
      '& .MuiTypography-root':{
        fontWeight:'500',
      }
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingBottom: '0 !important',
    alignItems:'center',
    padding:0,
  },
  logoContainer: {
    display: 'inline-flex',
    height: '40px',
    width: '40px',
    marginBottom:20,
  },
  title: {
    fontWeight: 300,
    fontSize: '20px',
    lineHeight:'23.44px',
    textAlign:'center',
  },
  footer: {
    alignItems: 'flex-end',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
    padding: 0,
  },
}));
